import { render, staticRenderFns } from "./CommissionIndex.vue?vue&type=template&id=2f0513b2&"
import script from "./CommissionIndex.vue?vue&type=script&lang=js&"
export * from "./CommissionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports